import { useIntl } from 'react-intl';

import type { PriceCurrency } from '@packages/gql/generated/shopping/graphql';
import { usePriceFormatter } from '@packages/shared/src/hooks/usePriceFormatter/usePriceFormatter';

type PriceProps = {
  price: number | null;
  currency: PriceCurrency;
  free: boolean;
  mandatory: boolean;
};

/**
 * atom for Aplus - renders the service price.
 */
export const Price = ({ price, currency, free, mandatory }: PriceProps) => {
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormatter('APLUS');

  if (free) {
    return (
      <span className="text-size-body-sm/8 text-color-success-dark font-bold whitespace-nowrap">
        {mandatory
          ? formatMessage({
              id: 'aplus.inclusive',
              defaultMessage: 'inklusive',
            })
          : formatMessage({
              id: 'aplus.free',
              defaultMessage: 'gratis',
            })}
      </span>
    );
  }

  if (price) {
    return (
      <span className="text-size-body-sm/4 font-bold whitespace-nowrap">
        +{formatPrice(price, currency)}
      </span>
    );
  }

  return null;
};
